import { Component } from '@angular/core';
import {RouterLink} from "@angular/router";
import {HeroGlobalComponent} from "../../hero-global/hero-global.component";

@Component({
  selector: 'app-hero-promotions',
  standalone: true,
  imports: [
    RouterLink,
    HeroGlobalComponent
  ],
  templateUrl: '../../hero-global/hero-global.component.html',
  styleUrl: './hero-promotions.component.css'
})
export class HeroPromotionsComponent {
  namePage='Paquetes Promocionales';
  linkPage='/promociones';



}
